import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Modal from '../components/Modal';

const API_BASE = process.env.REACT_APP_API_BASE || '';

function CampaignDetailPage() {
  const { id } = useParams();
  const campaignId = Number(id);
  const [campaign, setCampaign] = useState(null);
  const [leads, setLeads] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [query, setQuery] = useState('');
  const [minRating, setMinRating] = useState('');
  const [minReviews, setMinReviews] = useState('');
  const [notesDraft, setNotesDraft] = useState('');
  const [notesStatus, setNotesStatus] = useState('');
  const [panelOpen, setPanelOpen] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);

  const fetchCampaign = async () => {
    const res = await fetch(`${API_BASE}/backend/campaigns_list.php`);
    const data = await res.json();
    if (data.ok) {
      const found = data.campaigns.find((c) => Number(c.id) === campaignId);
      setCampaign(found || null);
    }
  };

  const fetchLeads = async () => {
    if (!campaignId) return;
    const res = await fetch(`${API_BASE}/backend/leads_list.php?campaign_id=${campaignId}`);
    const data = await res.json();
    if (data.ok) setLeads(data.leads);
  };

  const fetchLead = async (leadId) => {
    if (!leadId) return;
    const res = await fetch(`${API_BASE}/backend/lead_view.php?id=${leadId}`);
    const data = await res.json();
    if (data.ok) {
      setSelectedLead(data.lead);
      setNotesDraft(data.lead.notes || '');
      setNotesStatus('');
      setPanelOpen(true);
    }
  };

  useEffect(() => {
    fetchCampaign();
    fetchLeads();
  }, [campaignId]);

  const filteredLeads = leads.filter((lead) => {
    const q = query.trim().toLowerCase();
    if (q) {
      const hay = [
        lead.name,
        lead.phone,
        lead.website,
        lead.city,
        lead.domain,
      ].join(' ').toLowerCase();
      if (!hay.includes(q)) return false;
    }
    if (minRating) {
      const r = Number(lead.rating || 0);
      if (r < Number(minRating)) return false;
    }
    if (minReviews) {
      const r = Number(lead.reviews || 0);
      if (r < Number(minReviews)) return false;
    }
    return true;
  });

  return (
    <div className={`detail-layout ${panelOpen ? 'with-panel' : 'no-panel'}`}>
      <div className="detail-main">
        <section className="card">
          <div className="row spread">
            <div>
              <p className="eyebrow">Campaign</p>
              <h2>{campaign ? campaign.name : 'Campaign Detail'}</h2>
              {campaign && <div className="muted">Created {campaign.created_at}</div>}
            </div>
            <Link className="button" to="/campaigns">Back to Campaigns</Link>
          </div>
        </section>

        <section className="card">
          <div className="row spread">
            <div>
              <h3>Leads</h3>
              <div className="muted">{filteredLeads.length} of {leads.length} leads</div>
            </div>
            <div className="filters">
              <label>
                Search
                <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Name, phone, website..." />
              </label>
              <label>
                Min Rating
                <input value={minRating} onChange={(e) => setMinRating(e.target.value)} placeholder="4.0" />
              </label>
              <label>
                Min Reviews
                <input value={minReviews} onChange={(e) => setMinReviews(e.target.value)} placeholder="10" />
              </label>
            </div>
          </div>
          <div className="table scrollable">
          <div className="table-row head">
            <div>Name</div>
            <div>Phone</div>
            <div>Website</div>
            <div>City</div>
            <div>Rating</div>
          </div>
          {filteredLeads.map((l) => (
            <div
              key={l.id}
              className={`table-row clickable ${selectedLead?.id === l.id ? 'active' : ''}`}
              onClick={() => fetchLead(l.id)}
            >
              <div>{l.name}</div>
              <div>{l.phone}</div>
              <div className="truncate">
                {l.website ? (
                  <a href={l.website} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                    Open Website
                  </a>
                ) : '-'}
              </div>
              <div>{l.city}</div>
              <div>{l.rating}</div>
            </div>
          ))}
        </div>
      </section>
      </div>

      <aside className={`sidepanel overlay ${panelOpen ? 'open' : 'closed'}`}>
        <div className="sidepanel-header">
          <h3>Lead Detail</h3>
          <button className="button ghost" onClick={() => setPanelOpen(false)}>
            Close
          </button>
        </div>
        {panelOpen && !selectedLead && <div className="muted">Select a lead to view details.</div>}
        {panelOpen && selectedLead && (
          <div className="sidepanel-body">
            <div className="row spread">
              <span className="muted">{notesStatus}</span>
              <button className="primary" onClick={() => setNotesOpen(true)}>Notes</button>
            </div>
            <div className="toggle-grid">
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={Number(selectedLead.dnc) === 1}
                  onChange={async (e) => {
                    const form = new FormData();
                    form.append('id', selectedLead.id);
                    form.append('field', 'dnc');
                    form.append('value', e.target.checked ? 1 : 0);
                    const res = await fetch(`${API_BASE}/backend/lead_toggle.php`, {
                      method: 'POST',
                      body: form,
                    });
                    const data = await res.json();
                    if (data.ok) setSelectedLead({ ...selectedLead, dnc: data.value });
                  }}
                />
                <span>DNC</span>
              </label>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={Number(selectedLead.consent) === 1}
                  onChange={async (e) => {
                    const form = new FormData();
                    form.append('id', selectedLead.id);
                    form.append('field', 'consent');
                    form.append('value', e.target.checked ? 1 : 0);
                    const res = await fetch(`${API_BASE}/backend/lead_toggle.php`, {
                      method: 'POST',
                      body: form,
                    });
                    const data = await res.json();
                    if (data.ok) setSelectedLead({ ...selectedLead, consent: data.value });
                  }}
                />
                <span>Consent</span>
              </label>
            </div>
            <div className="detail-grid">
              <div><span>Name</span>{selectedLead.name || '-'}</div>
              <div><span>Phone</span>{selectedLead.phone || '-'}</div>
              <div><span>Website</span>{selectedLead.website ? (
                <a href={selectedLead.website} target="_blank" rel="noreferrer">Open Website</a>
              ) : '-'}</div>
              <div><span>Address</span>{selectedLead.address || '-'}</div>
              <div><span>Status</span>{selectedLead.status || '-'}</div>
              <div><span>Attempts</span>{selectedLead.call_attempts || 0}</div>
              <div><span>Last Called</span>{selectedLead.last_called_at || '-'}</div>
              <div><span>Rating</span>{selectedLead.rating || '-'}</div>
              <div><span>Reviews</span>{selectedLead.reviews || '-'}</div>
              <div><span>Biz Status</span>{selectedLead.business_status || '-'}</div>
              <div><span>Maps</span>{selectedLead.maps_url || '-'}</div>
              <div><span>Place ID</span>{selectedLead.place_id || '-'}</div>
              <div><span>Source</span>{selectedLead.source_query || '-'}</div>
              <div><span>City</span>{selectedLead.city || '-'}</div>
              <div><span>Created</span>{selectedLead.created_at || '-'}</div>
            </div>
          </div>
        )}
      </aside>

      {notesOpen && selectedLead && (
        <Modal title="Lead Notes" onClose={() => setNotesOpen(false)}>
          <div className="notes">
            <textarea
              value={notesDraft}
              onChange={(e) => setNotesDraft(e.target.value)}
              placeholder="Add notes about this lead..."
            />
            <div className="row spread">
              <span className="muted">{notesStatus}</span>
              <button
                className="primary"
                onClick={async () => {
                  const form = new FormData();
                  form.append('id', selectedLead.id);
                  form.append('notes', notesDraft);
                  const res = await fetch(`${API_BASE}/backend/lead_update.php`, {
                    method: 'POST',
                    body: form,
                  });
                  const data = await res.json();
                  if (data.ok) {
                    setNotesStatus('Saved');
                    setSelectedLead({ ...selectedLead, notes: notesDraft });
                  } else {
                    setNotesStatus(data.error || 'Save failed');
                  }
                }}
              >
                Save Notes
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default CampaignDetailPage;
